import { ANIMATION_TIMINGS } from './ANIMATION_TIMINGS';
import { useStaggerAnimation } from './useStaggerAnimation';

export const useSidebarActionsStaggerAnimation = (
	onStaggeringAnimationTimeout?: () => void,
): {
	shouldAnimate: boolean;
	resetAnimation: () => void;
} => {
	return useStaggerAnimation({
		delay: ANIMATION_TIMINGS.sidebarActions,
		onStaggeringAnimationTimeout,
	});
};
